import { ContextMenu, ContextMenuItem } from "@/components/ui";
import type { DefaultMatterFileRepositoryStructureFolder } from "@/lib/types";
import { FolderPlus } from "lucide-react";
import type { ReactNode } from "react";

type DefaultFolderStructureContextMenuProps = {
  canCreate: boolean;
  canDelete: boolean;
  folder: DefaultMatterFileRepositoryStructureFolder;
  onCreateSubfolder: () => void;
  onDelete: () => void;
  trigger: ReactNode;
};

export function DefaultFolderStructureContextMenu({
  canCreate,
  canDelete,
  folder,
  onCreateSubfolder,
  onDelete,
  trigger,
}: DefaultFolderStructureContextMenuProps) {
  return (
    <ContextMenu
      entityName="folder"
      copy={{ label: "Copy folder name", value: folder.name }}
      delete={canDelete ? { onSelect: onDelete } : false}
      trigger={trigger}
    >
      {canCreate ? (
        <ContextMenuItem onSelect={onCreateSubfolder}>
          <FolderPlus />
          New subfolder
        </ContextMenuItem>
      ) : null}
    </ContextMenu>
  );
}
